// extracted by mini-css-extract-plugin
module.exports = {"btn":"BotonSkills_btn__3eFdj","selectedSkill":"BotonSkills_selectedSkill__wlbVi"};